import React, { useEffect, useState, useContext } from "react"
import axios from "axios"
import { useBeforeunload , Beforeunload} from "react-beforeunload"
import * as channelJson from "../../../static/channel.json"
import { Link, navigate, withPrefix } from "gatsby"
import Header from "../Header"
import Footer from "../Footer"
import JourneyOne from "../journey/journey-1"
import Disclaimers from "../disclaimers"
import CPchooseplan from "../cp-chooseplan"
import Ekyc from "../sections/ekyc/ekyc"
import { JourneyContext } from "../context/journeyContext"
import { decryptUrl, saveDropoutTimeStamp, getIpAddress, getJWTTokenForIp, channelJourneyCheck, paymentText, getConfigurationsByType } from "../../services/apiservice"
import { findCurrentJourneyCode, getKeyFromValueLookup } from "../services/helperFunctions"
import Rmled from "../../pages/rmled"
import base64 from 'base-64'
import * as lookup from "../../../static/lookup.json"
import { errorToastr } from "../../services/error-handler"
import { refreshToken } from "../../interceptors/jwt-interceptor"
import BQP from "../../pages/bqp-redirection"
import OfflineNotice from "../common/OfflineNotice"
import { clearAllCookies } from "../../shared/functions"
var CryptoJS = require("crypto-js");
const Layout = props => {
  // console.log("layout props",props)
  const [channel, setchannel] = useState("")
  const [channelProperty, setChannelProperty] = useState({})
  const [decryptData, setDecryptData] = useState()
  const [isRedirected, setIsRedirected] = useState(false)
  const [isNavigateToRM, setIsNavigateToRM] = useState(false)
  const [journeyId, setJourneyId] = useState()
  const [rmData,setRmData] = useState({})
  const [BQPData,setBQPData] = useState({})
  const channelList = channelJson.data.channels
  const [allChannel, setAllChannel] = useState(false);
  const [isNavigateToBQP, setIsNavigateToBQP] = useState(false)
  const [isConfigLoaded, setIsConfigLoaded] = useState(false)

  const [journeyState, setJourneyState] = useContext(JourneyContext);

  useEffect(() => {
    (async () => {
      if (props.paymentData && props.paymentData.decryptData && props.paymentData.payloadJson) {
        try {
          if ((["A", "B", "C", "D","30"].includes(props.paymentData.payloadJson.source))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.paymentData.payloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if ((["hsbc", "canara", "pnb", "others", "equitas", "36"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase()))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == props.paymentData.payloadJson.source?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if(["website","pbp"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase())) {
              setchannel( props?.paymentData?.payloadJson?.source?.toUpperCase());
              setChannelProperty(channelList[3]);
              channelTheme();
              setIsRedirected(false);
              setIsNavigateToRM(false);
          } else{
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.paymentData.payloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId)
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }
        }
        catch(e)
        {
          console.log("asdasd",e)
        }
      }else if (props.enachData && props.enachData.enachDecryptData && props.enachData.enachPayloadJson) {
        try {
          if ((["A", "B", "C", "D","30"].includes(props.enachData.enachPayloadJson.source))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.enachData.enachPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if ((["hsbc", "canara", "pnb", "others", "equitas" ].includes(props?.paymentData?.payloadJson?.source?.toLowerCase()))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == props.enachData.enachPayloadJson.source?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if(["website","pbp"].includes(props?.enachData?.enachPayloadJson.source?.toLowerCase())) {
              setchannel( props?.enachData?.enachPayloadJson?.source?.source?.toUpperCase());
              setChannelProperty(channelList[3]);
              channelTheme();
              setIsRedirected(false);
              setIsNavigateToRM(false);
          } else{
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.enachData.enachPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId)
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }
        }
        catch(e)
        {
          console.log("asdasd",e)
        }
      }else if (props.lienData && props.lienData.lienDecryptData && props.lienData.lienPayloadJson) {
        try {
          if ((["A", "B", "C", "D","30"].includes(props.lienData.lienPayloadJson.source))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.lienData.lienPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if ((["hsbc", "canara", "pnb", "others", "equitas", "36"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase()))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == props.lienData.lienPayloadJson.source?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }else if(["website","pbp"].includes(props?.lienData?.lienPayloadJson?.source?.toLowerCase())) {
              setchannel( props?.lienData?.lienPayloadJson?.source?.toUpperCase());
              setChannelProperty(channelList[3]);
              channelTheme();
              setIsRedirected(false);
              setIsNavigateToRM(false);
          } else{
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.lienData.lienPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId)
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }
        }
        catch(e)
        {
          console.log("asdasd",e)
        }
      }else if (props.digilockerdata && props.digilockerdata.digilockerDecryptData && props.digilockerdata.digilockerPayloadJson) {
        try {
          if ((["A", "B", "C", "D","30","36"].includes(props.digilockerdata.digilockerPayloadJson.source))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.digilockerdata.digilockerPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          } else if ((["hsbc", "canara", "pnb", "others"].includes(props?.paymentData?.payloadJson?.source?.toLowerCase()))) {
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == props.digilockerdata.digilockerPayloadJson.source?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element);
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }else if(["website","pbp"].includes(props?.digilockerdata?.digilockerPayloadJson?.source?.toLowerCase())) {
              setchannel( props.digilockerdata.digilockerPayloadJson.source?.toUpperCase());
              setChannelProperty(channelList[3]);
              channelTheme();
              setIsRedirected(false);
              setIsNavigateToRM(false);
          }else{
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == getKeyFromValueLookup("reverseChannelType", props.digilockerdata.digilockerPayloadJson.source)?.toUpperCase()) {
                setchannel(element.channelId)
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
              }
            })
          }
        }
        catch(e)
        {
          console.log("asdasd",e)
        }
      }
      else if (props.location.search) {
        const urlParams = new URLSearchParams(props.location.search)
        if (urlParams) {
          setIsRedirected(true);
          queryFunction(urlParams);
        }
      } else if(props.resumeJourneyData){
        if(props.resumeJourneyData.applicationData?.journeyData?.basicDetails?.channel){
          let fetchedChannel;
          if(!(["A","B","C","D","36"].includes(props.resumeJourneyData.applicationData?.journeyData?.basicDetails?.channel))){
            fetchedChannel = props.resumeJourneyData.applicationData?.journeyData?.basicDetails?.channel;
            setchannel(fetchedChannel);
            setChannelProperty(channelList[3]);
            channelTheme();
            setIsRedirected(false);
            setIsNavigateToRM(false);
            // setIsPaymentData(true);
          }else{
            fetchedChannel = getKeyFromValueLookup("reverseChannelType", props.resumeJourneyData.applicationData?.journeyData?.basicDetails?.channel);
            channelList.forEach(element => {
              if (element.channelId.toUpperCase() == fetchedChannel?.toUpperCase()) {
                setchannel(element.channelId);
                setChannelProperty(element)
                channelTheme()
                setIsRedirected(false)
                setIsNavigateToRM(false)
                // setIsPaymentData(true);
              }
            })
          }
        }
        if(props?.resumeJourneyData?.journeyData?.paymentFrequency){
          setJourneyState(prev => {
          return({
            ...prev,
            paymentFrequency: props?.resumeJourneyData?.journeyData?.paymentFrequency
          })
        })
        }
      } else if (props.fnaData) {
        setIsRedirected(false)
        setIsNavigateToBQP(false)
        setIsNavigateToRM(false)
        if (props.fnaData.BQPData) {
          setchannel(props.fnaData.BQPData.channelName)
          const otherChannel = channelJson.data.channels.find(channel => channel.channelId === "others")
          const otherChannelCssRules = otherChannel.csskeyvalue
          otherChannelCssRules.forEach(cssRule => {
            document.documentElement.style.setProperty(cssRule.cssKey, cssRule.cssValue);
          })
          document.documentElement.style.setProperty("--lumiq-img-url", `url(${withPrefix('/images/icon-others.png')})`);
          document.documentElement.style.setProperty("--lumiq-checkbox", `url(${withPrefix('/images/chek-box-others.png')})`);
          // setchannel(fnaData.BQPData.channelName) 
          // set the theme
        }
        else {
        setchannel("A")
        setChannelProperty("HSBC")
        channelTheme()
      }
      }else if(props.canaraPosData){
        setchannel("C")
        setChannelProperty(channelList[1])
        channelTheme()
        setIsRedirected(false)
        setIsNavigateToRM(false)
      }else {
        navigate("/invalidChannel")
        // if (!channel) {
        //   setchannel("others")
        //   setAllChannel(true)
        //   // setIsNavigateToRM(true);
        // }
        // // without query Params
        // channelList.forEach(element => {
        //   if (element.channelId == "others") {
        //     setchannel(element.channelId)
        //     setChannelProperty(element)
        //   }
        // })
        // channelTheme()
      }
    })()
  
  }, [channel,props])

  useEffect(() => {
    const fetchBlacklist = async () => {
      try {
        const blacklistRes = await getConfigurationsByType({ type: "blacklisted-countries" });
        if (blacklistRes?.data && blacklistRes.data[0]?.config) {
          const blacklist = blacklistRes.data[0].config;
          const blacklistedCodes = Object.keys(blacklist);

          const countryKeyLookups = [
            "country",
            "countryWithoutIndia",
            "countryCodeToCountry",
            "countryRegex",
            "countryToCountryCode",
          ];

          if (
            lookup.countryToCountryCode?.[0] &&
            lookup.phoneCountryCodes?.[0]
          ) {
            blacklistedCodes.forEach((code) => {
              const phoneCode = lookup.countryToCountryCode[0][code];
              if (phoneCode) {
                delete lookup.phoneCountryCodes[0][phoneCode];
              }
            });
          }
           countryKeyLookups.forEach((key) => {
            if (lookup[key]?.[0]) {
              blacklistedCodes.forEach((code) => {
                delete lookup[key][0][code];
              });
            }
          });
        }
      } catch (e) {
        console.info("blacklisted-countries failed", e);
      } finally {
        setIsConfigLoaded(true);
      }
    };

    fetchBlacklist();
  }, []);

  useEffect(() => {
    const journeyIdFromStrapi = journeyState.journeyIdFromStrapi;
    const source = getSource(props);

    const checkJourney = async () => {
      if (!journeyIdFromStrapi) {
        console.info('Channel or journey ID is missing.');
        return;
      }

      try {
        const journeyRes = await channelJourneyCheck(
          source || "",
          journeyIdFromStrapi,
          props?.resumeJourneyData?.journeyData
        );

        if (!journeyRes.valid) {
          navigate("/ProductNotAvailablePage");
        }
      } catch (err) {
        console.info("channelJourneyCheck failed", err);
        navigate("/ProductNotAvailablePage");
      }
    };

    checkJourney();
  }, [channel, props.resumeJourneyData?.journeyData, journeyState.journeyIdFromStrapi]);

  const getSource = (props) => {
    if(props?.location?.search){
      const urlParams = new URLSearchParams(props.location.search);
      const source = urlParams.get("source");
      return source.toLowerCase();
    }
    if(journeyState.channel){
      const channelA = journeyState.channel;
      let channelsearchA = lookup.MediaPartnerCode.find(element => element.ISNP_CHANNEL_TYPE.toLowerCase() === channelA?.toLowerCase())
      const sourceA = channelsearchA?.ITEM_CODE.toLowerCase();
      return sourceA;
    }
    if(props.resumeJourneyData){
      const channelB = props.resumeJourneyData.journeyData.basicDetails.channel
      let channelsearchB = lookup.MediaPartnerCode.find(element => element.ISNP_CHANNEL_TYPE.toLowerCase() === channelB?.toLowerCase())
      const sourceB = channelsearchB?.ITEM_CODE.toLowerCase();
      return sourceB;
    }
    if(props.paymentData){
      let channelC = props.paymentData.payloadJson.source
      if (channelC.length > 1){
        return props.paymentData.payloadJson.source.toLowerCase()
      }else{
        let channelsearchC = lookup.MediaPartnerCode.find(element => element.ISNP_CHANNEL_TYPE.toLowerCase() === channelC?.toLowerCase())
        const sourceC = channelsearchC?.ITEM_CODE.toLowerCase();
        return sourceC;
      }
    }
    if(props?.fnaData?.BQPData?.channelName){
      const channel = props?.fnaData?.BQPData?.channelName;
      let channelsearch = lookup.MediaPartnerCode.find(element => element.ITEM_CODE.toLowerCase() === channel?.toLowerCase())
      const source = channelsearch?.ITEM_CODE.toLowerCase();
      return source;
    }
  }

  async function queryFunction(urlParams) {
    const parameter1 = urlParams.get("data")
    const parameter2 = urlParams.get("source")?.toUpperCase();
    const parameter3 = urlParams.get("journeyId")
    const parameter4 = urlParams.get("CSIDPROC")?.toUpperCase();
    setJourneyId(parameter3);

    getConfigurationsByType({ type: "bqpPageChannels" })
    .then((bqpConfig) => {
      let redirectToBQPPage;
      redirectToBQPPage = bqpConfig.data?.[0]?.config?.validChannels?.includes(parameter2?.toUpperCase()) || false
      if (redirectToBQPPage) {
        setIsNavigateToBQP(true)
        setIsRedirected(false)
        setIsNavigateToRM(false)
        setchannel(parameter2)
        return
      }
    })
    .catch(() => {
      console.info("error in fetching bqp config")
    })

    // Corporate Discount activation via CSIDPROC
    if (parameter4 && parameter4 === "Y") {
      setJourneyState(prev => ({
        ...prev,
        corpDiscOpt: "Y"
      }))
    } else if (parameter4 && parameter4 !== "Y") {
      navigate("/invalidChannel")
      return
    } else {
      setJourneyState(prev => ({
        ...prev,
        corpDiscOpt: "N"
      }))
    }
    if(["HSBC","CANARA","OTHERS", "EQUITAS"].includes(parameter2?.toUpperCase())){
      channelList.forEach(element => {
        if (element.channelId.toUpperCase() == parameter2) {
          setchannel(element.channelId);
          setChannelProperty(element);
          setAllChannel(true);
        }
      })
    }
    else{
      let paramenterInMediaPartner = lookup.MediaPartnerCode.findIndex(element => element.ITEM_CODE === parameter2)
      if(paramenterInMediaPartner !== -1){
        setchannel(parameter2);
        setChannelProperty(channelList[3]);
        setAllChannel(true);
      }else{
        navigate("/invalidChannel")
      }
      
    }
    channelTheme();
    if (parameter2 && !parameter1) {
      if (parameter2 === "HSBC") {
        if(parameter3){
          setIsRedirected(false)
          setIsNavigateToRM(false)
        }else{
          setIsRedirected(false)
          setIsNavigateToRM(true)
        }
      } else {
        setIsRedirected(false)
        setIsNavigateToRM(false)
      }
    } else {
      if (parameter1 && parameter2 && channel) {
        setIsNavigateToRM(false);
        getIpAddress()
          .then(async res => {
            let payload = {
              ip: res.IPv4
            }
            if (refreshToken) {
              const payload = {
                data: parameter1,
                source: parameter2,
              }
              try {
                const res = await decryptUrl(payload)
                console.log(res)
                setDecryptData(res)
              } catch (err) {
                setIsRedirected(false)
                console.log(err)
              }
            } else {
              getJWTTokenForIp(payload)
                .then(async res => {
                  const payload = {
                    data: parameter1,
                    source: parameter2,
                  }
                  try {
                    const res = await decryptUrl(payload)
                    console.log(res)
                    if(res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.uid){
                      setJourneyState(prev => ({
                        ...prev,
                        uid: res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.uid || ""
                      }))
                    }
                    // check if utmparams are there then set that in setJourneyState
                    if(res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_source || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_medium || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_campaign || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_term || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_content || res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_cohort){
                      setJourneyState(prev => ({
                        ...prev,
                        utmParams: {
                          utm_source: res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_source || "",
                          utm_medium: res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_medium || "",
                          utm_campaign: res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_campaign || "",
                          utm_term: res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_term || "",
                          utm_content: res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_content || "",
                          utm_cohort: res?.journeyPayload?.[0]?.pageData?.[0]?.sectionData?.utm_cohort || "",
                        }
                      }))
                    }
                    
                    setDecryptData(res)
                  } catch (err) {
                    setIsRedirected(false)
                    console.log(err)
                  }
                })
            }
          })

      }
    }
  }
  function channelTheme() {
    if (channel && channelProperty && channelProperty.csskeyvalue) {
      const cssArr = channelProperty.csskeyvalue;
      cssArr.forEach(element => {
        document.documentElement.style.setProperty(
          element.cssKey,
          element.cssValue
        )
      });
      if(channel == "hsbc" || channel == "canara" || channel == "pnb" || ["EQUITAS","equitas","36"].includes(channel)){
        document.documentElement.style.setProperty("--lumiq-img-url",`url(${withPrefix(`/images/icon-${channel.toLocaleLowerCase()}.png`)})`)
        document.documentElement.style.setProperty("--lumiq-checkbox",`url(${withPrefix(`/images/chek-box-${channel.toLocaleLowerCase()}.png`)})`);
      }else{
        document.documentElement.style.setProperty("--lumiq-img-url",`url(${withPrefix('/images/icon-others.png')})`)
        document.documentElement.style.setProperty("--lumiq-checkbox",`url(${withPrefix('/images/chek-box-others.png')})`);
      }
    }
    else {
      document.documentElement.style.setProperty("--lumiq-primary", "#000000")
      document.documentElement.style.setProperty("--lumiq-secondary", "#404040")
      document.documentElement.style.setProperty("--lumiq-header", "#db0011")
      document.documentElement.style.setProperty("--lumiq-secondary2", "#404040")
      document.documentElement.style.setProperty("--lumiq-hover", "#404040")
      document.documentElement.style.setProperty("--lumiq-footer-bg", "#404040")
      document.documentElement.style.setProperty("--lumiq-footer-color", "#fff")
      document.documentElement.style.setProperty("--lumiq-footer-icon-color", "#c4c4c4")
      document.documentElement.style.setProperty("--lumiq-footer-bg2", "none")
      document.documentElement.style.setProperty("--lumiq-footer-border", "1px solid #fff")
      document.documentElement.style.setProperty("--lumiq-footer-shadow", "none")
      document.documentElement.style.setProperty("--lumiq-footer-bold", "100")
      document.documentElement.style.setProperty("--lumiq-bg", "#ededed")
      document.documentElement.style.setProperty("--lumiq-card-bg", "#3e505d")
      document.documentElement.style.setProperty("--lumiq-img-url", `url(${withPrefix('/images/icon-others.png')})`);
      document.documentElement.style.setProperty("--lumiq-checkbox",`url(${withPrefix('/images/chek-box-others.png')})`);
      document.documentElement.style.setProperty("--lumiq-error", "#db0011");
      document.documentElement.style.setProperty("--image-color", "#db0011");
    }

  }

  useEffect(() => {
    channelTheme()
  }, [channel, channelProperty])

  const isJourneyStart = (rmData)=> {
    setIsNavigateToRM(false);
    setAllChannel(true);
    setRmData(rmData)
  }

  const isJourneyStartBQP = (data)=> {
    setIsNavigateToBQP(false)
    setAllChannel(true);
    setBQPData(data)
  }

   const aesEncryptData = data => {
    if (typeof window === "undefined") {
      return
    }
    else
    return  CryptoJS.AES.encrypt(JSON.stringify(data), `${process.env.DECRYPT_KEY}`).toString();
  }
  return (
    <>
    <Beforeunload onBeforeunload={async (event) => {
    clearAllCookies();
    let journeyId = journeyId || journeyState.journeyId || "3221"
    if(journeyId !== "3221"){
      let payload ={
        journeyId: journeyId
      }
      let encryptData = aesEncryptData(payload)
      console.log("datae", encryptData);
      let encryptedPayload = {
        encryptData: encryptData
      }
      const apiUrl = process.env.GATASBY_API_URL
      let res = await axios.post(`${apiUrl}/save-dropout-timestamp`, encryptedPayload)
      console.log(res)
    }
      // .then(res => {
      //   console.log(res)
      // })
      // .catch(error => {
      //   console.log(error)
      // })
  }}>
      {console.log("journey details",isRedirected, isNavigateToRM, props.resumeJourneyData, journeyId)}
      <Header />
        {
          !isConfigLoaded ? null :
          isRedirected ? 
        (
          decryptData && (
            <JourneyOne
              resumeJourneyData={props.resumeJourneyData}
              decryptData={decryptData}
              channel ={channel}
            />
          )
        ) : 
        isNavigateToRM && channel === "hsbc"
          ? (<Rmled isJourneyStart={isJourneyStart}/>)
          : isNavigateToBQP 
          ?(<BQP isJourneyStartBQP={isJourneyStartBQP} resumeJourneyData={props?.resumeJourneyData}/>) 
          : Object.keys(rmData).length > 0
          ? (<JourneyOne rmData={rmData}/>) 
          : props.resumeJourneyData
          ? (<JourneyOne resumeJourneyData={props.resumeJourneyData}/>) 
          : journeyId 
          ? (<JourneyOne journeyId={journeyId}/>) 
          : props.paymentData && props.paymentData.payloadJson && props.paymentData.decryptData
          ? (<JourneyOne paymentData={props.paymentData} />) 
          : props.enachData && props.enachData.enachDecryptData && props.enachData.enachPayloadJson
          ? (<JourneyOne enachData={props.enachData} />) 
          : props.lienData && props.lienData.lienDecryptData && props.lienData.lienPayloadJson
          ? (<JourneyOne lienData={props.lienData} />)
          : props.digilockerdata && props.digilockerdata.digilockerDecryptData && props.digilockerdata.digilockerPayloadJson
          ? (<JourneyOne digilockerdata={props.digilockerdata} />) 
          : props.fnaData
          ? (<JourneyOne fnaData={props.fnaData} />)
          : props.canaraPosData
          ? (<JourneyOne canaraPosData={props.canaraPosData} />)
          :allChannel ? (<JourneyOne channel={channel}/>):(<></>)
        }
      <Footer />
      <OfflineNotice />
      </Beforeunload>
    </>
  )
}

export default Layout
